module.exports = require('./src/google-maps-api-loader.js');



//////////////////
// WEBPACK FOOTER
// ./~/google-maps-api-loader/index.js
// module id = 1032
// module chunks = 18